<template>
    <div>
        <b-loading :is-full-page=true v-model="isLoadingFullPage" ></b-loading>

        <section class="mr-5 ml-5 mt-5 mb-5">
           <nav class="level is-mobile">
            <div class="level-left">
                <div class="level-item">
                      <h1 class="title is-1"><span> <b-icon
                            icon="cart-outline"
                            size="is-large"
                            type="is-danger">
                        </b-icon></span> Cart</h1>
                </div>
                 
            </div>

             <div class="level-right">
                <div class="level-item">
                   <p class="subtitle is-4 is-spaced mt-2"> <span>{{rowsPrepareToInvoiceModel.length}}</span> รายการ </p>
                </div>

                <div class="level-item ml-5">
                   <p class="subtitle is-4 is-spaced mt-2">  จำนวนเงิน <span>{{formatStringToCurrency(totalPrice)}}</span> บาท </p>
                </div>
             </div>       
           </nav>
           
            <nav class="level is-mobile">
						<div class="level-left">
                            <div class="level-item">
                                 <b-button type="" class="mr-3" icon-left="arrow-left" @click="backToParepareMakeInvSearchItems">Back</b-button>
                            </div>    
                            <div class="level-item has-text-weight-semibold has-text-primary mr-5">
                                Member ID : <span class="ml-5 has-text-info" v-if="memberIDParamsForMakeInvPrepareWantModel == null"> N/A</span> 
                                            <span class="ml-5 has-text-info" v-else >{{memberIDParamsForMakeInvPrepareWantModel.member_id}} / {{memberIDParamsForMakeInvPrepareWantModel.name.substring(0,25)}} </span> 
                                          <b-button type="is-success is-light ml-5"
                                            @click="showSearchMemberPatho(1)"
                                            icon-right="magnify" />  
							</div>
						</div>


                        <div class="level-right">
                           <div class="level-item">
                                <b-button type="is-danger" class="mr-3" icon-left="delete" @click="rowsPrepareToInvoiceModel=[]">Delete All</b-button>
                            </div> 
                           <div class="level-item">
                                <b-button type="is-info is-light" 
                                          class="mr-3" 
                                          icon-left="database-arrow-right-outline" 
                                          @click="toMakeInvoice"
                                          :disabled = "memberIDParamsForMakeInvPrepareWantModel == null && rowsPrepareToInvoiceModel.length != 0 "
                                >Make Invoice</b-button>
                            </div>
                        </div>
					</nav>



                      <b-table
                                :data="isEmpty ? [] : rowsPrepareToInvoiceModel "
                                bordered
                                 
                                narrowed
                                hoverable  
                                striped   
                                focusable 
                                
                                :loading="isTableLoading"
                                
                                mobile-cards

                                paginated
                                :per-page="perPageTbl2"
                                :current-page.sync="currentPageTbl2"

                           
                        >

                      

                        <b-table-column  label="No"   centered   v-slot="props">
                           {{props.index + 1}}
                        </b-table-column> 


                        <b-table-column  label="รหัส" field="idpart"  centered   v-slot="props">
                            {{ props.row.idpart }} 
                        </b-table-column>   
                        <b-table-column  label="รายการ"  v-slot="props">
                            {{ props.row.descp }} 
                        </b-table-column> 
                        <b-table-column  label="จำนวน" centered v-slot="props">
                            {{formatStringToCurrency( props.row.amount ) }} 
                        </b-table-column> 
                        <b-table-column  label="หน่วยนับ" centered v-slot="props">
                            {{ props.row.unit_part_txt }} 
                        </b-table-column> 

                        <b-table-column  label="ราคา" centered v-slot="props">
                            {{ formatStringToCurrency(props.row.price) }} 
                        </b-table-column> 


                        <b-table-column  label="idlab" centered v-slot="props">
                            {{ props.row.idlab }} 
                        </b-table-column> 

                        <b-table-column  label="Order ID" centered v-slot="props">
                            {{ props.row.idlabnonautomate }} 
                        </b-table-column> 

                        <b-table-column  label="ผู้บันทึก" centered v-slot="props">
                            {{ props.row.user_rec_fn }} 
                        </b-table-column> 


                        <b-table-column  label="บันทึกเมื่อ" centered v-slot="props">
                           <span  :class="props.row.status != -1 ? 'is-size-6' : 'has-text-danger is-size-6' ">
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).date }}  
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).month }} 
                                    {{  getISO8601ToYearMonthDate( props.row.dt_rec ).year }} 
                                 </span> 
                                     


                                 <span  :class="props.row.status != -1 ? 'is-size-7 is-italic' : 'has-text-danger is-size-7 is-italic' "  >
                                     {{  getISO8601ToYearMonthDate( props.row.dt_rec ).hour }}:{{  getISO8601ToYearMonthDate( props.row.dt_rec ).minute }} 
                                 </span>  
                        </b-table-column> 

                        <b-table-column  label="LMID" centered v-slot="props">
                            {{ props.row.member_id }} 
                        </b-table-column> 

                        <b-table-column  label="ชื่อสมาชิก" centered v-slot="props">
                            {{ props.row.patho_member_name }} 
                        </b-table-column> 


                        <b-table-column  label="Visit no/Job ID" centered v-slot="props">
                            {{ props.row.visit_no }} 
                        </b-table-column> 
                        <b-table-column  label="OPD No." field="opd_no"  centered     v-slot="props">
                            {{ props.row.opd_no }} 
                        </b-table-column> 
                        <b-table-column  label="OPD Name" centered v-slot="props">
                            {{ props.row.opd_name }} 
                        </b-table-column> 

                        <b-table-column  label="Owner" centered v-slot="props">
                            {{ props.row.owner_name }}  {{ props.row.owner_surname }} 
                        </b-table-column> 
                         
                        <b-table-column  label="#" centered v-slot="props">
                            <b-button type="is-danger"
                            @click="deleteFromRowsPrepareToInvoice(props.row)"
                            icon-right="delete" />
                        </b-table-column>  
                      


                     



                        <template slot="empty">
                                <section class="section">
                                    <div class="content has-text-grey has-text-centered">
                                        <p>
                                            <b-icon
                                                    icon="emoticon-sad"
                                                    size="is-large">
                                            </b-icon>
                                        </p>
                                        <p>Nothing here.</p>
                                    </div>
                                </section>
                        </template>



                </b-table>   





        </section>

        <b-modal
                v-if="isSearchMemberPathoShowing"
                v-model="isSearchMemberPathoShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SearchMemberPatho v-if="isSearchMemberPathoShowing"
                     :isShowing="isSearchMemberPathoShowing"
                     :mode="modeSearchMemberPatho"
                   
                     @memberIDSelected_ForInv="memberIDSelected_ForInv"
                     @close="closeSearchMemberPatho"
                     
            />
     </b-modal>




    </div>
</template>


<script>
import {  mapState , mapMutations, mapActions  } from 'vuex'
import formatStringToCurrency from '../../../mixins/methods/formatStringToCurrency'
import getISO8601ToYearMonthDate from '../../../mixins/methods/getISO8601ToYearMonthDate'
import SearchMemberPatho from './SearchMemberPatho.vue'
import axios from "axios";
import { getBaseURLforBackEnd , getConfigAxios  } from '@/utils.js'




export default {
    name : "PrepareMakeInvoice_Cart",
    mixins:[formatStringToCurrency,getISO8601ToYearMonthDate,],
    components:{
     SearchMemberPatho,
    },
    methods:{
        ...mapMutations({
            setMemberIDParamsForMakeInvPrepareWant: 'patho_invoice/setMemberIDParamsForMakeInvPrepareWant',
            setRowsPrepareToInvoice: 'patho_invoice/setRowsPrepareToInvoice',
            
        }), 

        ...mapActions({
            fetchUsedPartPathoFromMonthYear : 'patho_invoice/fetchUsedPartPathoFromMonthYear',
        }),
        closeSearchMemberPatho(){
             this.isSearchMemberPathoShowing = false
        },
        toMakeInvoice(){
            this.isLoadingFullPage = true
            const datTo = {
                   "member_id" : this.memberIDParamsForMakeInvPrepareWant.id, 
                   "sum_price" :  this.totalPrice ,
                   "used_part_patho_id_arr" : this.rowsPrepareToInvoice.map(dat=>dat.used_part_patho_id)
            }
      
            axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
            axios.post(`${getBaseURLforBackEnd()}/api/to_mark_patho_invoice`,datTo,getConfigAxios())
                 .then((res)=>{
                      // if success
                      this.rowsPrepareToInvoiceModel = [] // clear
                      // showmessage  invoice_id
                       this.$buefy.snackbar.open({
                            duration: 1000,
                            message : `Success with Invoice No is ${res.data.invoice_id}`
                            })

                      // refresh
                      this.fetchUsedPartPathoFromMonthYear()
                          .then(()=>{
                            this.isLoadingFullPage = false
                          }) 
                      // back route
                      this.$router.push(`/preparemakeinvoice_searchitems`)
                        .catch(()=>{});
                       
                 })

        }, 
        memberIDSelected_ForInv(payload){
            this.setMemberIDParamsForMakeInvPrepareWant(payload)
            this.isSearchMemberPathoShowing = false
        },
        deleteFromRowsPrepareToInvoice(_payload){
            const tmp = this.rowsPrepareToInvoiceModel.find(dat=>dat.used_part_patho_id == _payload.used_part_patho_id)
            const tmpIndex = this.rowsPrepareToInvoiceModel.indexOf(tmp)
            this.rowsPrepareToInvoiceModel.splice(tmpIndex,1)
        }, 
        backToParepareMakeInvSearchItems(){
            this.$router.push(`/preparemakeinvoice_searchitems`)
                        .catch(()=>{});
        },
        showSearchMemberPatho(_mode){
            this.modeSearchMemberPatho = _mode
            this.isSearchMemberPathoShowing = true
        },
    },
    computed:{

        ...mapState({
            access_token : state => state.master_data.access_token ,

            memberIDParamsForMakeInvPrepareWant: state => state.patho_invoice.memberIDParamsForMakeInvPrepareWant ,
            rowsPrepareToInvoice: state => state.patho_invoice.rowsPrepareToInvoice ,

		}),


        rowsPrepareToInvoiceModel:{
                get: function () {
                    return this.rowsPrepareToInvoice
                },
                set: function (newValue) {
                    this.setRowsPrepareToInvoice(newValue)
                }
        },
        memberIDParamsForMakeInvPrepareWantModel:{
                get: function () {
                    return this.memberIDParamsForMakeInvPrepareWant
                },
                set: function (newValue) {
                    this.setMemberIDParamsForMakeInvPrepareWant(newValue)
                }
        },

        totalPrice(){
            // return this.rowsPrepareToInvoice.map(dat=>dat.price*dat.amount)
            //                                 .reduce((acc,cur)=>acc+cur,0)
            return this.rowsPrepareToInvoice.map(dat=>dat.price)
                                    .reduce((acc,cur)=>acc+cur,0)
        }
    },
    data(){
        return{
            isLoadingFullPage : false,
            isSearchMemberPathoShowing : false,
            modeSearchMemberPatho :  1 , // 0 --> search for searchParamsSearchItems , 1 --> search for searchParamsForMakeInv
            isEmpty: false,
            isTableLoading : false,

            perPageTbl2 : 20,
            currentPageTbl2 : 1,
        }
    }
}
</script>